// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"up-arrow_linkButtonWrapper__pOy8g","linkButton":"up-arrow_linkButton__1vuHi","arrowWrapper":"up-arrow_arrowWrapper__wfWwJ"};